import { Component, Element, h, Host, Listen } from '@stencil/core';
import { SearchResponseEntry } from '../../../../../../types/global'; // eslint-disable-line import/extensions
import store from '../../../../../global/store';

interface HTMLElementWithBank extends HTMLElement {
  bank?: SearchResponseEntry;
}
/**
 * Serves as a mediator between Bank Search and Ui-Cms-Webforms.
 * Provides selectedBank to and handles events coming from the form.
 */
@Component({
  tag: 'ui-bank-search-webform',
  styleUrl: 'ui-bank-search-webform.scss',
  shadow: false,
})
export class UiBankSearchWebform {
  @Element() el: HTMLElement;

  // TODO: Get rid of webform-general, -praemienaktion, -savings-plan, or maybe bank-search-webform
  // Maybe get rid of slotting in a form at all, instead provide the form-id as a prop? Basically,
  // the whole bank-search-webform > bank-search-webform-general > cms-webforms > webforms seems
  // a little convoluted.

  @Listen('uiCmsWebformsSubmit', { target: 'body' })
  onFormSubmit() {
    // console.log('📯 form has been submitted');
  }

  // In order to reset the webform, another Listener is located in ui-bank-search-webform-general,
  // which is provided as a slot, obscuring any reference to ui-cms-webforms here.
  @Listen('uiCmsWebformsClose', { target: 'body' })
  onFormClose() {
    // Do NOT remove search values. "selectedBank" should ONLY be removed when
    // a) selecting a new bank or
    // b) clicking the X-icon in search input
    store.state.isOverlayVisible = false;
  }

  slot: HTMLElementWithBank;

  componentWillLoad() {
    this.slot = this.el.firstElementChild as HTMLElementWithBank;
    this.injectBank();

    store.onChange('selectedBank', () => {
      this.onSelectedBankChange();
    });
  }

  onSelectedBankChange() {
    this.injectBank();
  }

  injectBank() {
    this.slot.bank = store.state.selectedBank;
  }

  render() {
    return (
      <Host class="form-content">
        <div class="form-content__container">
          <slot />
        </div>
      </Host>
    );
  }
}
